import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "lucide-react";

import { cn } from "@/lib/utils";

function Accordion({
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
}

function AccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn("aero:border-b aero:last:border-b-0", className)}
      {...props}
    />
  );
}

function AccordionTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="aero:flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          "aero:focus-visible:border-ring aero:focus-visible:ring-ring/50 aero:flex aero:flex-1 aero:items-start aero:justify-between aero:gap-4 aero:!rounded-md aero:py-4 aero:text-left aero:text-sm aero:font-medium aero:transition-all aero:outline-none aero:hover:underline aero:focus-visible:ring-[3px] aero:disabled:pointer-events-none aero:disabled:opacity-50 aero:[&[data-state=open]>svg]:rotate-180",
          className
        )}
        {...props}
      >
        {children}
        <ChevronDownIcon className="aero:text-muted-foreground aero:pointer-events-none aero:size-4 aero:shrink-0 aero:translate-y-0.5 aero:transition-transform aero:duration-200" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="aero:data-[state=closed]:animate-accordion-up aero:data-[state=open]:animate-accordion-down aero:overflow-hidden aero:text-sm"
      {...props}
    >
      <div className={cn("aero:pt-0 aero:pb-4", className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
